"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconDone = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconDone = function SvgIconDone(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59999 6.00002C1.59999 3.56997 3.56994 1.60002 5.99999 1.60002C6.80242 1.60002 7.55299 1.81428 8.19956 2.1883C8.48639 2.35422 8.85343 2.25621 9.01936 1.96937C9.18528 1.68253 9.08727 1.3155 8.80043 1.14957C7.97613 0.672742 7.019 0.400024 5.99999 0.400024C2.9072 0.400024 0.399994 2.90723 0.399994 6.00002C0.399994 9.09282 2.9072 11.6 5.99999 11.6C9.09279 11.6 11.6 9.09282 11.6 6.00002C11.6 5.61725 11.5615 5.24284 11.488 4.88067C11.4221 4.55592 11.1054 4.3461 10.7806 4.41202C10.4559 4.47794 10.246 4.79464 10.312 5.11938C10.3696 5.40343 10.4 5.69787 10.4 6.00002C10.4 8.43008 8.43005 10.4 5.99999 10.4C3.56994 10.4 1.59999 8.43008 1.59999 6.00002ZM10.4243 3.42429C10.6586 3.18997 10.6586 2.81008 10.4243 2.57576C10.1899 2.34145 9.81004 2.34145 9.57573 2.57576L5.49999 6.6515L4.42426 5.57576C4.18994 5.34145 3.81004 5.34145 3.57573 5.57576C3.34142 5.81007 3.34142 6.18997 3.57573 6.42429L5.07573 7.92429C5.31004 8.1586 5.68994 8.1586 5.92426 7.92429L10.4243 3.42429Z",
    fill: "currentColor"
  }));
};

exports.SvgIconDone = SvgIconDone;